module.exports = __webpack_public_path__ + "img/icon-not-found.fd76c3e0.png";